import * as M from 'materialize-css';
import Vue from 'vue';
import '../scss/styles.scss';
// import { Creative } from '@andromeda/calvera-core/lib/services/selectable/cru';
import IntegratedRetailer from '../models/IntegratedRetailer';
import { RecipeCarouselItem } from '../models/RecipeCarousel';

export default Vue.extend({
	name: 'RecipeCarousel',
	props: {
		footerLogo: {
			type: String,
			required: false,
		},
		creativeConfig: {
			type: Object as any,
			required: false,
		},
		recipeCarousel: {
			type: Array as () => RecipeCarouselItem[],
			required: true,
		},
		indicators: {
			type: Boolean,
			required: false,
			default: false,
		},
		dist: {
			type: Number,
			required: false,
			default: 0,
		},
		padding: {
			type: Number,
			required: false,
			default: -125,
		},
		numVisible: {
			type: Number,
			required: false,
			default: 10,
		},
		duration: {
			type: Number,
			required: false,
			default: 500,
		},
		creative: {
			type: Object,
			required: false,
		},
		adCopy: {
			type: String,
			required: false,
		},
		address: {
			type: Object as () => IntegratedRetailer,
			required: false,
		},
		showAddress: {
			type: Boolean,
			required: false,
			default: false,
		},
		retailerName: {
			type: String,
			required: false,
		},
		showCheckoutTotal: {
			type: Boolean,
			required: false,
			default: false,
		},
		checkoutTotal: {
			type: Number,
			required: false,
			default: 0,
		},
		integratedRetailer: {
			type: String,
			required: false,
			default: '',
		},
	},
	data() {
		return {
			currentHeadlineIndex:
				this.recipeCarousel.length &&
				this.recipeCarousel[0].Description.length
					? 0
					: -1,
			carousel: HTMLElement,
			mCarousel: null as any | null,
			// @ts-ignore
			defaultAdCopy: '',
			currentContent: '',
			currentContentIndex: -1,
			adArray: [],
			checkoutClassName: `checkout ${this.integratedRetailer}`,
		};
	},
	mounted() {
		this.start();
		this.updateCarousel();
		this.setCurrentContent();
		setInterval(this.setCurrentContent, 1700);
	},
	methods: {
		updateCarousel() {
			if (this.mCarousel) {
				this.mCarousel.destroy();
			}
			const elem: Element =
				document.querySelector('.carousel') ||
				(this.$refs['carousel'] as Element);
			if (!elem || !elem.children.length) {
				return;
			}
			M.Carousel.init(elem, {
				indicators: this.indicators,
				dist: this.dist,
				padding: this.padding,
				numVisible: this.numVisible,
			});
			this.mCarousel = M.Carousel.getInstance(elem);
			const self = this;
			self.mCarousel.set(1);
			setTimeout(() => {
				self.mCarousel.next(3);
				setTimeout(() => self.mCarousel.prev(3), 1500);
			}, 1000);
		},
		start() {
			const vm = this;
			setInterval(() => {
				if (!vm.recipeCarousel.length) {
					return;
				}
				vm.currentHeadlineIndex += 1;
				if (
					vm.currentHeadlineIndex >=
					vm.recipeCarousel[0].Description.length
				) {
					vm.currentHeadlineIndex = 0;
				}
			}, 4000);
		},
		buttonClicked() {
			this.$emit('actionBtnClicked');
		},
		setCurrentContent() {
			const regex = '{KROGER_CHAIN}';
			this.adArray = this.adCopy
				? this.adCopy.split('|')
				: this.defaultAdCopy.split('|');
			if (!this.adArray.length) this.currentContent = '';
			if (this.currentContentIndex + 1 > this.adArray.length) {
				this.currentContentIndex = -1;
			} else {
				this.currentContentIndex += 1;
				const content: string = this.adArray[this.currentContentIndex];
				if (content && content.length) {
					this.currentContent = content
						.replace(regex, this.address.Chain)
						.trim();
				}
			}
		},
		updated() {
			this.updateCarousel();
		},
	},
	watch: {
		recipeCarousel: {
			// eslint-disable-next-line object-shorthand
			handler: function () {
				const elem: Element =
					document.querySelector('.carousel') ||
					(this.$refs['carousel'] as Element);
				this.updateCarousel();
				this.$forceUpdate();
				if (this.recipeCarousel.length !== elem.children.length) {
					window.setTimeout(this.updateCarousel, 500);
				}
			},
		},
		creative: {
			// eslint-disable-next-line object-shorthand
			handler: function () {
				this.setCurrentContent();
			},
		},
		adCopy: {
			// eslint-disable-next-line object-shorthand
			handler: function () {
				this.setCurrentContent();
			},
		},
	},
	beforeDestroy() {
		if (this.mCarousel) {
			this.mCarousel.destroy();
		}
	},
});
